import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getDepreciationList } from '@store/Finance/FixedAssets/Depreciation/DepreciationSlice';
// import { useTranslation } from 'react-i18next';

const useGetDepreciationList = () => {
  const dispatch = useAppDispatch();
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (AssetsList?.length === 0) {
    dispatch(getDepreciationList());
    // }
  }, []);
  const { DepreciationList, loading, error } = useAppSelector(state => state.Depreciation);

  // var OptionsAssets = Retirement?.map(({ id, name, name2 }) => ({
  //   value: id,
  //   label: `${i18n.language === 'en' ? name : name2}`,
  // }));

  return { DepreciationList, loading, error };
};

export default useGetDepreciationList;
